import React, { useState } from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, LinkedinIcon, CheckCircle2Icon } from 'lucide-react';
import { PageShell } from '../components/PageShell';
import { SectionHeading } from '../components/SectionHeading';
import { inquiryTypes, profile } from '../data/profile';
export function ContactPortal() {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [email, setEmail] = useState('');
  const [inquiryType, setInquiryType] = useState(inquiryTypes[0]);
  const [message, setMessage] = useState('');
  const inputClass = 'w-full border border-platinum-300 bg-white px-4 py-3 font-sans text-sm text-navy-900 outline-none transition-colors duration-150 ease-out placeholder:text-charcoal-600/60 focus:border-gold-600';
  const labelClass = 'block font-sans text-xs font-semibold uppercase tracking-[0.14em] text-charcoal-600';
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted(true);
  };
  return <PageShell path="/contact" data-id="element-254" data-mp="3m44c21cx4dbr">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="contact-heading" data-id="element-255" data-mp="3m3cg2pfesdky">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-256" data-mp="37g9ikir364xm">
          <div className="lg:col-span-5" data-id="element-257" data-mp="3cd9omtnxr7oq">
            <div id="contact-heading" data-id="element-258" data-mp="3cc81vrxk4wr6">
              <SectionHeading eyebrow="Direct Contact" title="Reach Yolandi directly" data-id="element-259" data-mp="2yejpl8hk2xxq" />
            </div>

            <dl className="mt-10 divide-y divide-platinum-200 border-y border-platinum-200" data-id="element-260" data-mp="32hg2cikezztr">
              <div className="flex items-center gap-4 py-5" data-id="element-261" data-mp="2ohf4lbzg58ii">
                <MailIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-262" data-mp="2tfoylj9fq32j" />
                <div className="min-w-0" data-id="element-263" data-mp="2thjlh349o599">
                  <dt className={labelClass} data-id="element-264" data-mp="mozaqkjpv896">Email</dt>
                  <dd className="mt-1 truncate font-sans text-base font-medium text-navy-900" data-id="element-265" data-mp="mnfs4nal8l48">
                    <a href={`mailto:${profile.email}`} className="transition-colors duration-150 ease-out hover:text-gold-600" data-id="element-266" data-mp="rm94gce5262t">
                      {profile.email}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex items-center gap-4 py-5" data-id="element-267" data-mp="b9xd5sop3eid">
                <PhoneIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-268" data-mp="bbqj15rhhupb" />
                <div data-id="element-269" data-mp="18x4pg32wa5v5">
                  <dt className={labelClass} data-id="element-270" data-mp="18zqt3rmo0183">Direct line</dt>
                  <dd className="mt-1 font-sans text-base font-medium text-navy-900" data-id="element-271" data-mp="13zmg4bkytomm">
                    <a href={`tel:${profile.phone.replace(/\s/g, '')}`} className="transition-colors duration-150 ease-out hover:text-gold-600" data-id="element-272" data-mp="z72z14n2kbd2">
                      {profile.phone}
                    </a>
                  </dd>
                </div>
              </div>
              <div className="flex items-center gap-4 py-5" data-id="element-273" data-mp="1mw4cx7eo8epq">
                <MapPinIcon className="h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-274" data-mp="1v6v09fo1cuh3" />
                <div data-id="element-275" data-mp="1z753wlocv8ss">
                  <dt className={labelClass} data-id="element-276" data-mp="1z8g7akdw2ejd">Based in</dt>
                  <dd className="mt-1 font-sans text-base font-medium text-navy-900" data-id="element-277" data-mp="24718am0yt28v">
                    {profile.location}
                  </dd>
                </div>
              </div>
            </dl>

            <a href={profile.linkedIn} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center justify-center gap-2.5 whitespace-nowrap bg-navy-900 px-6 py-3.5 font-sans text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-navy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-600" data-id="element-278" data-mp="2e576otnkbq8z">
              <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-279" data-mp="2wtc99xshh567" />
              Connect on LinkedIn
            </a>

            <p className="mt-10 border-l-2 border-gold-500 pl-5 font-sans text-base leading-relaxed text-charcoal-700" data-id="element-280" data-mp="2giwas3giago">
              {profile.disclaimer}
            </p>
          </div>

          <div className="lg:col-span-7" data-id="element-281" data-mp="3tkzhhoc1y9as">
            <div className="border border-platinum-200 bg-platinum-100 p-8 lg:p-10" data-id="element-282" data-mp="c6lpotehpqfj">
              <h2 className="font-display text-xl font-bold tracking-tight text-navy-900" data-id="element-283" data-mp="76plat1vrwzg">
                Board inquiry
              </h2>
              <p className="mt-3 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-284" data-mp="3fnkn056xzbby">
                Submit a confidential enquiry regarding a directorship, advisory mandate or executive
                appointment. Responses are typically provided within two business days.
              </p>

              {submitted ? <div role="status" className="mt-8 flex items-start gap-4 border border-gold-500 bg-white p-6" data-id="element-285" data-mp="3koi5yjzs09ei">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-286" data-mp="zvdagzpr36ia" />
                  <div data-id="element-287" data-mp="17duqlos4tjk8">
                    <p className="font-display text-base font-bold text-navy-900" data-id="element-288" data-mp="17hs8k72z452j">Inquiry received</p>
                    <p className="mt-2 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-289" data-mp="1cc601yeils1x">
                      Thank you, {name || 'and welcome'}. Your enquiry has been logged and a response
                      will follow to the address provided.
                    </p>
                    <button type="button" onClick={() => setSubmitted(false)} className="mt-4 font-sans text-sm font-semibold text-gold-600 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-navy-900" data-id="element-290" data-mp="1q6p2uaydexkr">
                      Submit another enquiry
                    </button>
                  </div>
                </div> : <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-291" data-mp="2dvrjpgl6kme7">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-292" data-mp="2nri24gmmdxga">
                    <div data-id="element-293" data-mp="2npdvvs190mcu">
                      <label className={labelClass} htmlFor="inquiry-name" data-id="element-294" data-mp="2isn6uf7gugfa">
                        Full name
                      </label>
                      <input id="inquiry-name" name="name" required value={name} onChange={event => setName(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="Jane Director" data-id="element-295" data-mp="2eph1raw3avae" />
                    </div>
                    <div data-id="element-296" data-mp="1v3ccbfgpli9l">
                      <label className={labelClass} htmlFor="inquiry-organisation" data-id="element-297" data-mp="1v0gers8rwvlo">
                        Organisation
                      </label>
                      <input id="inquiry-organisation" name="organisation" required value={organisation} onChange={event => setOrganisation(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="Board or company name" data-id="element-298" data-mp="1m135p0oka91h" />
                    </div>
                  </div>

                  <div data-id="element-299" data-mp="akifiicljpzo">
                    <label className={labelClass} htmlFor="inquiry-email" data-id="element-300" data-mp="ajqtnz8sx6ml">
                      Email address
                    </label>
                    <input id="inquiry-email" name="email" type="email" required value={email} onChange={event => setEmail(event.target.value)} className={`mt-2 ${inputClass}`} placeholder="name@organisation.com" data-id="element-301" data-mp="39xstke720qv0" />
                  </div>

                  <div data-id="element-302" data-mp="2vahgu8z4z0tb">
                    <label className={labelClass} htmlFor="inquiry-type" data-id="element-303" data-mp="2v9y1n00veqiz">
                      Nature of enquiry
                    </label>
                    <select id="inquiry-type" name="inquiryType" value={inquiryType} onChange={event => setInquiryType(event.target.value)} className={`mt-2 ${inputClass}`} data-id="element-304" data-mp="1opi4jamdzmst">
                      {inquiryTypes.map(type => <option key={type} value={type} data-id="element-305" data-mp="27l864wqeqh66">
                          {type}
                        </option>)}
                    </select>
                  </div>

                  <div data-id="element-306" data-mp="2hb17z60qzhx8">
                    <label className={labelClass} htmlFor="inquiry-message" data-id="element-307" data-mp="2hef9yd5i1p45">
                      Details
                    </label>
                    <textarea id="inquiry-message" name="message" required rows={5} value={message} onChange={event => setMessage(event.target.value)} className={`mt-2 resize-y ${inputClass}`} placeholder="Mandate, timing and any relevant context." data-id="element-308" data-mp="2qcr76y0vfl5k" />
                  </div>

                  <button type="submit" className="inline-flex w-full items-center justify-center whitespace-nowrap bg-gold-500 px-6 py-3.5 font-sans text-sm font-semibold text-navy-950 transition-colors duration-150 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-600 sm:w-auto" data-id="element-309" data-mp="2w1dz21gvw7fp">
                    Submit board inquiry
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </section>
    </PageShell>;
}